import { z } from 'zod';
import { requiredString } from '../helpers';
export const Nice_Cxone_Handoff_1_ConfigValidator = z.object({
    connection: requiredString('NICE CXone Connection is required'),
    pointOfContactId: requiredString('Point of Contact ID is required'),
    customerName: z.string().optional(),
    customerEmail: z.string().optional(),
    customerPhone: z.string().optional()
});
//# sourceMappingURL=nice-cxone-handoff-1.js.map